import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { noHeaderCss } from "../../sass/Main";
import Paper from "@material-ui/core/Paper/index";
import Typography from "@material-ui/core/Typography/index";

class Alert extends React.Component {
  render() {
    const { classes } = this.props;
    const alertType = `${this.props.kind}Alert`;

    return (
      <Paper>
        <Typography elevation={1} component="p" className={[classes[alertType], classes.pSize].join(" ")}>
          {this.props.text}
        </Typography>
      </Paper>
    );
  }
}

export default withStyles(noHeaderCss)(Alert);
